/* eslint-disable react/sort-comp */
/* eslint-disable consistent-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {Table} from 'react-bootstrap';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import CheckBox from '@/components/checkBox/CheckBox';
import DateTime from '@/components/dateTimePicker/DateTimePicker';
import {HISTORY_SHOW_TYPE_DATE_OPTION, TARE_STAGE_ENUM} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog, consoleError} from '@/libs/consoleHelper';
import {DateAddDay, DateSubtractDay} from '@/libs/dateHelper';

import {VOLUME_SENSOR_LABEL} from '../../../constants/calibrationWizardConstant';

import BottomMenu from './components/BottomMenuCalibHistory';
import {
  GetCalibrationHistoryList,
  SetCalibrationHistoryList,
  DeleteCalibrationHistory,
  DoTare,
  IsTareDone,
} from './data/CalibrationHistoryData';

import './CalibrationHistory.less';
import '../CalibrationLoadCellSensor.less';

const HISTORY_SHOW_TYPE = {
  ALL: 'ALL',
  DATE: 'DATE',
};
@connect((store) => ({
  fontSize: store.setupStore.fontSize,
}))
class CalibrationHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonProps: {
        id: HISTORY_SHOW_TYPE_DATE_OPTION.SEARCH_FILTER,
        showType: HISTORY_SHOW_TYPE.DATE,
        showDateTime: false,
        dateFormat: DateTime.format.date,
        timeFormat: false,
        searchFilter: new Date(),
        value: new Date().toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'}),
        valueDateTimePopup: new Date(),
        onClick: this.onClick,
        onCloseDatePicker: this.onCloseDatePicker,
      },
      // cycleHistoryList: [],
      // cycleTextList: [],
      // allCycleHistoryList: [],
      // showCycleHistory: [],
      // lastCycleHistoryId: 0,
      allCalibrationHistoryData: [],
      calibrationHistoryData: [],
      selectedCalibrationHistory: undefined,
      isSelectorActive: false,
      isCalibrationHistoryAvailable: false,
      isCallDoTareSuccess: false,
      isTareDone: false,
      isTareSuccess: false,
      isLoadSuccess: false,
    };

    this._isTareDonePooling = undefined;
    this.onClickRow = this.onClickRow.bind(this);
  }

  async componentDidMount() {
    const calibrationHistoryData = await this.GetDataCalibrationHistory();
    // consoleLog("calibrationHistoryData ", calibrationHistoryData);
    // const dummycalibrationHistoryData = [
    //   {
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.ID]: '1',
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.IS_ACTIVE]: 'false',
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME]: '02/02/2020 17:17:17',
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_REF_WEIGHT]: '50',
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_SCALE]: '77',
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_REF_WEIGHT]: '50',
    //     [APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_SCALE]: '78',
    //   },
    // ];
    let newShowCalibrationData = [];
    if (this.state.buttonProps.showType === HISTORY_SHOW_TYPE.ALL) {
      newShowCalibrationData = calibrationHistoryData;
    } else {
      calibrationHistoryData.forEach((data) => {
        if (data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME] !== undefined) {
          const dateTime = data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME].split(' ');
          const date = new Date(dateTime[0]).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          });
          // consoleLog("Date ", { dateTime, date, button: this.state.buttonProps.value });
          if (date === this.state.buttonProps.value) {
            newShowCalibrationData = [...newShowCalibrationData, data];
          }
        }
      });
    }
    this.setState({
      calibrationHistoryData: [...newShowCalibrationData],
      allCalibrationHistoryData: [...calibrationHistoryData],
    });
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.CALIBRATION_HISTORY));
    this.calibrationHistoryTopMenu();
  }

  // --------------------------------------------- Get/Set Data ---------------------------------------
  async GetDataCalibrationHistory() {
    try {
      const data = GetCalibrationHistoryList();
      if (data !== undefined && data !== null) {
        this.setState({
          isCalibrationHistoryAvailable: true,
        });
      } else {
        this.setState({
          isCalibrationHistoryAvailable: false,
        });
      }
      return data;
    } catch (error) {
      consoleError('[GetCalibrationHistory] -', error);
    }
  }

  async SetDataCalibrationHistory(params) {
    try {
      const data = SetCalibrationHistoryList(params);
      return data;
    } catch (error) {
      consoleError('[CalibrationHistory] -', error);
    }
  }

  async DeleteDataCalibrationHistory(params) {
    try {
      const data = DeleteCalibrationHistory(params);
      return data;
    } catch (error) {
      consoleError('[DeleteCalibrationHistory] -', error);
    }
  }

  // eslint-disable-next-line consistent-return
  async CallDoTare() {
    try {
      const tareStage = {
        Stage: TARE_STAGE_ENUM.History,
      };
      const isTareSuccess = await DoTare(tareStage);
      let successCount = 0;
      const tareStatusCheck = [];
      if (isTareSuccess[VOLUME_SENSOR_LABEL.Protein] === true) {
        tareStatusCheck.push(APPDATA.KEY.ProteinTube);
        successCount += 1;
      }
      if (isTareSuccess[VOLUME_SENSOR_LABEL.Buffer] === true) {
        tareStatusCheck.push(APPDATA.KEY.BufferTube);
        successCount += 1;
      }
      if (successCount === 2) {
        consoleLog('CallDoTare', {state: this.state, isTareSuccess});
        this.setState({
          isCallDoTareSuccess: true,
        });
        this._isTareDonePooling = await this.poolingIsTareDone(tareStatusCheck);
      } else {
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.TARE_FAILED_TEXT,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
        // this._bus.publish("SET_TOPMENU_COMPLATE", STEP_WIZARD.NoTubeCalibration)
      }
      return isTareSuccess;
    } catch (error) {
      consoleError('[DoTare] -', error);
    }
  }

  poolingIsTareDone = (tareStatusCheck) => {
    const tareDoneId = setInterval(async () => {
      await this.GetIsTareDone(tareStatusCheck);
    }, 300);

    return tareDoneId;
  };

  // eslint-disable-next-line consistent-return
  async GetIsTareDone(tareStatusCheck) {
    try {
      const IstareDoneStatus = await IsTareDone();
      let totalDone = 0;
      let totaltrue = 0;
      let totalfalse = 0;
      tareStatusCheck.forEach((value) => {
        if (IstareDoneStatus[value].IsDone === true) {
          totalDone += 1;
          if (IstareDoneStatus[value].IsAboveFailureThreshold) totalfalse += 1;
          else totaltrue += 1;
        }
      });
      consoleLog('GetIsTareDone', {state: this.state, IstareDoneStatus});
      if (totalDone === tareStatusCheck.length) {
        this.setState({
          isTareDone: true,
        });
        if (totalfalse > 0) {
          this.setState({
            isTareSuccess: false,
          });
          if (typeof this._isTareDonePooling !== 'undefined') clearInterval(this._isTareDonePooling);
          const param = {
            Id: this.state.selectedCalibrationHistory[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID],
          };
          const setCalibration = await this.SetDataCalibrationHistory(param);
          consoleLog('setCalibration', setCalibration);
          if (setCalibration) {
            const popUpButton = [
              {
                id: APPDATA.FIELD_NAME.CHECK_SCALES,
                isPrimaryButton: true,
                onClick: this.onClickSubmitConfirmation,
                label: APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase(),
                className: 'calibrationHistoryPopupButton ',
              },
              {
                id: APPDATA.CLOSE,
                isPrimaryButton: false,
                onClick: this.onClickSubmitConfirmation,
                label: APPDATA.CLOSE.toUpperCase(),
                // className: "calibrationHistoryPopupButton "
              },
            ];
            this.props.dispatch(
              modalActions.showPopUp({
                popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TITLE,
                popUpText:
                  APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD
                    .SUCCESS_LOAD_CALIBRATION_TARE_OFFSET,
                popUpButton,
              }),
            );
          } else {
            this.props.dispatch(
              setupActions.showAlert({
                alertShow: true,
                alertText:
                  APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.FAILED_LOAD_CALIBRATION,
                alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
              }),
            );
          }
        }
        if (totaltrue === tareStatusCheck.length) {
          if (typeof this._isTareDonePooling !== 'undefined') clearInterval(this._isTareDonePooling);
          this.setState(
            {
              isTareSuccess: true,
            },
            async () => {
              // if (this.state.isCallDoTareSuccess && this.state.isTareDone && this.state.isTareSuccess) {
              const param = {
                Id: this.state.selectedCalibrationHistory[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID],
              };
              const setCalibration = await this.SetDataCalibrationHistory(param);
              consoleLog('setCalibration', setCalibration);
              if (setCalibration) {
                // this.props.dispatch(setupActions.showAlert({
                //     alertShow: true,
                //     alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION,
                //     alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS
                // }));
                this.setState({
                  isLoadSuccess: true,
                });
                const popUpButton = [
                  {
                    id: APPDATA.FIELD_NAME.CHECK_SCALES,
                    isPrimaryButton: true,
                    onClick: this.onClickSubmitConfirmation,
                    label: APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase(),
                    className: 'calibrationHistoryPopupButton ',
                  },
                  {
                    id: APPDATA.CLOSE,
                    isPrimaryButton: false,
                    onClick: this.onClickSubmitConfirmation,
                    label: APPDATA.CLOSE.toUpperCase(),
                    // className: "calibrationHistoryPopupButton "
                  },
                ];
                this.props.dispatch(
                  modalActions.showPopUp({
                    popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TITLE,
                    popUpText:
                      APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION,
                    popUpButton,
                  }),
                );
              } else {
                this.props.dispatch(
                  setupActions.showAlert({
                    alertShow: true,
                    alertText:
                      APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.FAILED_LOAD_CALIBRATION,
                    alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
                  }),
                );
                window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
              }
              // }
              // else {
              //     this.props.dispatch(setupActions.showAlert({
              //         alertShow: true,
              //         alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.FAILED_LOAD_CALIBRATION,
              //         alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER
              //     }));
              // }
            },
          );
        }
      }
      return IstareDoneStatus;
    } catch (error) {
      consoleError('[DoTare] -', error);
    }
  }

  //   async loadCalibrationConfirmation() {
  //     const popUpButton = [
  //       {
  //         id: APPDATA.LOAD,
  //         isPrimaryButton: true,
  //         onClick: () => this.SetCalibrationHistory(),
  //         label: APPDATA.LOAD,
  //       },
  //       {
  //         id: APPDATA.CANCEL,
  //         isPrimaryButton: false,
  //         onClick: this.onClickSubmitConfirmation,
  //         label: APPDATA.CANCEL,
  //       },
  //     ];
  //     this.props.dispatch(
  //       modalActions.showPopUp({
  //         popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TITLE,
  //         popUpText: (
  //           <div>
  //             <div
  //               className=""
  //               style={{marginBottom: '25px'}}
  //             >
  //               {APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TEXT}
  //             </div>
  //           </div>
  //         ),
  //         popUpButton,
  //         hideCloseButton: true,
  //       }),
  //     );
  //   }

  async SetCalibrationHistory() {
    try {
      const param = {
        Id: this.state.selectedCalibrationHistory[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID],
      };
      const setCalibration = await this.SetDataCalibrationHistory(param);
      consoleLog('setCalibration', setCalibration);
      if (setCalibration) {
        const popUpButton = [
          {
            id: APPDATA.CLOSE,
            isPrimaryButton: false,
            onClick: this.onClickSubmitConfirmation,
            label: APPDATA.CLOSE.toUpperCase(),
            // className: "calibrationHistoryPopupButton "
          },
          {
            id: APPDATA.FIELD_NAME.CHECK_SCALES,
            isPrimaryButton: true,
            onClick: this.onClickSubmitConfirmation,
            label: APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase(),
            className: 'calibrationHistoryPopupButton ',
          },
        ];
        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TITLE,
            // popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION,
            popUpButton,
          }),
        );
      } else {
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.FAILED_LOAD_CALIBRATION,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
          }),
        );
      }
    } catch (error) {
      consoleError('[DoTare] -', error);
    }
  }

  onClickRow(calibrationData) {
    this.setState(
      {
        selectedCalibrationHistory: calibrationData,
      },
      () => {
        // consoleLog("Row clicked : ", this.state.selectedCalibrationHistory)
        this.calibrationHistoryTopMenu();
      },
    );
  }

  /// --------------------------------------- Start Top Menu --------------------------------------------------
  calibrationHistoryTopMenu = () => {
    const topButtonProperties = undefined;
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.onClickTopMenu,
    };
    const titleMenuProperties = APPDATA.CALIBRATION_HISTORY;

    const secondaryButton = undefined;
    // consoleLog("calibrationHistoryTopMenu ", {topButtonProperties, backButtonProperties, titleMenuProperties, secondaryButton});
    this.setupTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties, secondaryButton);
  };

  onClickTopMenu = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.USE_SELECTED_VALUE:
        // this.tubbeAttached(false);
        // this.loadCalibrationConfirmation();
        this.SetCalibrationHistory();
        break;
      case APPDATA.DELETE_HISTORY:
        this.DeleteHistoryModal(false);
        break;
      case APPDATA.BACK:
        window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_ADDRESS;
        break;
      default:
        break;
    }
  };

  DeleteHistoryModal(isChecked) {
    const popUpButton = [
      {
        id: APPDATA.DELETE_HISTORY,
        isPrimaryButton: true,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.OK,
        disabled: !isChecked,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.CANCEL,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_DELETE.TITLE,
        popUpText: (
          <div>
            <div
              className=""
              style={{marginBottom: '25px'}}
            >
              {APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_DELETE.TEXT}
            </div>
            <CheckBox
              id="tube_detached_checkbox"
              onChange={this.toggleCheckboxDeleteValue}
              value={isChecked}
              defaultChecked={isChecked}
              text={APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_DELETE.CHECKBOX}
            />
          </div>
        ),
        popUpButton,
      }),
    );
  }

  toggleCheckboxDeleteValue = (e) => {
    const isChecked = e.currentTarget.checked;
    this.DeleteHistoryModal(isChecked);
  };

  tubeAttached(isTubeDetached) {
    const popUpButton = [
      {
        id: APPDATA.OK,
        isPrimaryButton: true,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.OK,
        disabled: !isTubeDetached,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickSubmitConfirmation,
        label: APPDATA.CANCEL,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TITLE,
        popUpText: (
          <div>
            <div
              className=""
              style={{marginBottom: '25px'}}
            >
              {APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.TEXT}
            </div>
            <CheckBox
              id="tube_detached_checkbox"
              onChange={this.toggleCheckboxValue}
              value={isTubeDetached}
              defaultChecked={isTubeDetached}
              text={APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.CHECKBOX} // v
            />
          </div>
        ),
        popUpButton,
      }),
    );
  }

  toggleCheckboxValue = (e) => {
    const isTubeDetached = e.currentTarget.checked;
    this.tubeAttached(isTubeDetached);
  };

  onClickSubmitConfirmation = async (e) => {
    this.props.dispatch(modalActions.hidePopUp());
    switch (e.currentTarget.id) {
      case APPDATA.OK:
        await this.CallDoTare();
        consoleLog('CallDoTare', this.state);
        break;
      case APPDATA.DELETE_HISTORY: {
        const param = {
          Id: this.state.selectedCalibrationHistory[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID],
        };
        const deleteHistory = await this.DeleteDataCalibrationHistory(param);
        consoleLog('deleteHistory', deleteHistory);

        const calibrationHistoryData = await this.GetDataCalibrationHistory();
        let newShowCalibrationData = [];
        if (this.state.buttonProps.showType === HISTORY_SHOW_TYPE.ALL) {
          newShowCalibrationData = calibrationHistoryData;
        } else {
          calibrationHistoryData.forEach((data) => {
            // consoleLog("Data  History", data, newShowCalibrationData);
            if (data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME] !== undefined) {
              const dateTime = data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME].split(' ');
              const date = new Date(dateTime[0]).toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
              });
              // consoleLog("Date ", { dateTime, date, button: this.state.buttonProps.value, newShowCalibrationData });
              if (date === this.state.buttonProps.value) {
                newShowCalibrationData = [...newShowCalibrationData, data];
              }
            }
          });
        }
        this.setState({
          calibrationHistoryData: [...newShowCalibrationData],
          allCalibrationHistoryData: [...calibrationHistoryData],
        });
        break;
      }
      case APPDATA.CANCEL:
        break;
      case APPDATA.FIELD_NAME.CHECK_SCALES:
        window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CHECK_SCALE_ADDRESS;
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION_ALLERT,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
          }),
        );
        break;
      case APPDATA.CLOSE:
        // if (this.state.isCallDoTareSuccess && this.state.isTareDone && this.state.isTareSuccess && this.state.isLoadSuccess) {
        this.props.dispatch(
          setupActions.showAlert({
            alertShow: true,
            alertText:
              APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION_ALLERT,
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
          }),
        );
        // } else {
        //     this.props.dispatch(
        //         setupActions.showAlert({
        //             alertShow: true,
        //             alertText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.CALIBRATION_HISTORY_LOAD.SUCCESS_LOAD_CALIBRATION_TARE_OFFSET_ALLERT,
        //             alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        //         })
        //     );
        // }
        window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
        break;
      default:
        break;
    }
  };

  setupTopMenuProperties = (
    topButtonProperties,
    backButtonProperties,
    titleMenuProperties,
    topButtonSecondaryButtonProperties,
  ) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };
  /// --------------------------------------- End Top Menu --------------------------------------------------

  // ----------------------------------------- Start Bottom Menu ----------------------------------------------
  onClick = (e) => {
    const {buttonProps} = this.state;
    const newButtonProps = {...buttonProps};
    switch (e.currentTarget.id) {
      case HISTORY_SHOW_TYPE_DATE_OPTION.OLDER: {
        const subtractedDay = DateSubtractDay(buttonProps.searchFilter, 1);
        newButtonProps.searchFilter = subtractedDay;
        newButtonProps.value = subtractedDay.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
        this.setNewCycleHistoryListContent(newButtonProps);
        break;
      }
      case HISTORY_SHOW_TYPE_DATE_OPTION.SEARCH_FILTER:
        newButtonProps.id = HISTORY_SHOW_TYPE_DATE_OPTION.SEARCH_FILTER;
        newButtonProps.dateFormat = DateTime.format.date;
        newButtonProps.timeFormat = false;
        newButtonProps.showDateTime = true;
        newButtonProps.valueDateTimePopup = buttonProps.searchFilter;
        this.setState({
          buttonProps: newButtonProps,
        });
        break;
      case HISTORY_SHOW_TYPE_DATE_OPTION.NEWER: {
        const addedDay = DateAddDay(buttonProps.searchFilter, 1);
        newButtonProps.searchFilter = addedDay;
        newButtonProps.value = addedDay.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
        this.setNewCycleHistoryListContent(newButtonProps);
        break;
      }
      case HISTORY_SHOW_TYPE.DATE:
        newButtonProps.showType = HISTORY_SHOW_TYPE.DATE;
        this.setNewCycleHistoryListContent(newButtonProps);
        break;
      case HISTORY_SHOW_TYPE.ALL:
        newButtonProps.showType = HISTORY_SHOW_TYPE.ALL;
        this.setNewCycleHistoryListContent(newButtonProps);
        break;
      default:
        break;
    }
  };

  onCloseDatePicker = (id, value) => {
    const {buttonProps} = this.state;
    const newButtonProps = {...buttonProps};
    switch (id) {
      case HISTORY_SHOW_TYPE_DATE_OPTION.SEARCH_FILTER:
        newButtonProps.showDateTime = false;
        newButtonProps.searchFilter = value;
        newButtonProps.value = value.toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit'});
        this.setNewCycleHistoryListContent(newButtonProps);
        break;
      default:
        break;
    }
  };

  setNewCycleHistoryListContent = (newButtonProps) => {
    // consoleLog("newButtonProps", newButtonProps)
    let newShowCalibrationData = [];
    switch (newButtonProps.showType) {
      case HISTORY_SHOW_TYPE.DATE:
        this.state.allCalibrationHistoryData.forEach((data) => {
          if (data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME] !== undefined) {
            const dateTime = data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME].split(' ');
            const date = new Date(dateTime[0]).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            });
            // consoleLog("Date ", {dateTime, date, button:this.state.buttonProps.value});
            if (date === newButtonProps.value) {
              newShowCalibrationData = [...newShowCalibrationData, data];
            }
          }
        });
        break;
      case HISTORY_SHOW_TYPE.ALL:
        newShowCalibrationData = [...this.state.allCalibrationHistoryData];
        break;
      default:
        break;
    }
    // consoleLog("newShowCalibrationData", newShowCalibrationData)
    this.setState({
      buttonProps: newButtonProps,
      calibrationHistoryData: newShowCalibrationData,
    });
  };

  render() {
    const style = {
      constraint: {
        fontSize: this.props.fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : this.props.fontSize,
      },
    };
    const {calibrationHistoryData} = this.state;
    return (
      <div
        className="divCalibrationHistory"
        style={style.constraint}
      >
        {this.state.isCalibrationHistoryAvailable ? (
          <>
            <div className="tableCalibrationHistory">
              <Table
                striped
                bordered
                hover
                style={{borderRadius: '5px'}}
              >
                <thead>
                  <tr>
                    <th rowSpan="2">Date</th>
                    <th rowSpan="2">Time</th>
                    <th colSpan="3">{APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.SAMPLE_SCALE}</th>
                    <th colSpan="3">{APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.BUFFER_SCALE}</th>
                  </tr>
                  <tr>
                    <th>
                      {APPDATA.FIELD_NAME.WEIGHT} ({APPDATA.FIELD_NAME.MEASURES})
                    </th>
                    <th>{APPDATA.MESSAGES.CALIBRATION_HISTORY.SCALE_SLOPE}</th>
                    <th>{APPDATA.MESSAGES.CALIBRATION_HISTORY.TARE_OFFSET}</th>
                    <th>
                      {APPDATA.FIELD_NAME.WEIGHT} ({APPDATA.FIELD_NAME.MEASURES})
                    </th>
                    <th>{APPDATA.MESSAGES.CALIBRATION_HISTORY.SCALE_SLOPE}</th>
                    <th>{APPDATA.MESSAGES.CALIBRATION_HISTORY.TARE_OFFSET}</th>
                  </tr>
                </thead>
                <tbody>
                  {calibrationHistoryData.map((data) => {
                    // consoleLog("map data ", {index, data})
                    let clasName = '';
                    if (this.state.selectedCalibrationHistory !== undefined) {
                      if (
                        this.state.selectedCalibrationHistory[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID] ===
                        data[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID]
                      ) {
                        clasName = 'selected ';
                      }
                    }
                    if (data[APPDATA.MESSAGES.CALIBRATION_HISTORY.IS_ACTIVE] === true) {
                      clasName += 'isActiveHistory';
                    }
                    if (data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME] !== undefined) {
                      const dateTime = data[APPDATA.MESSAGES.CALIBRATION_HISTORY.DATE_TIME].split(' ');
                      return (
                        <tr
                          key={data[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID]}
                          className={clasName}
                          onClick={() => this.onClickRow(data)}
                        >
                          <td>{dateTime[0]}</td>
                          <td>{dateTime[1]}</td>
                          <td>{data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_REF_WEIGHT]}</td>
                          <td>
                            {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_SCALE]
                              ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_SCALE].toFixed(
                                  APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                                )
                              : '0'}
                          </td>
                          <td>
                            {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_OFFSET]
                              ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_OFFSET].toFixed(
                                  APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                                )
                              : '0'}
                          </td>
                          <td>{data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_REF_WEIGHT]}</td>
                          <td>
                            {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_SCALE]
                              ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_SCALE].toFixed(
                                  APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                                )
                              : '0'}
                          </td>
                          <td>
                            {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_OFFSET]
                              ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_OFFSET].toFixed(
                                  APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                                )
                              : '0'}
                          </td>
                        </tr>
                      );
                    }
                    return (
                      <tr
                        key={data[APPDATA.MESSAGES.CALIBRATION_HISTORY.ID]}
                        className={clasName}
                        onClick={() => this.onClickRow(data)}
                      >
                        <td />
                        <td />
                        <td>{data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_REF_WEIGHT]}</td>
                        <td>
                          {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_SCALE]
                            ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_SCALE].toFixed(
                                APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                              )
                            : '0'}
                        </td>
                        <td>
                          {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_OFFSET]
                            ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.SAMPLE_OFFSET].toFixed(
                                APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                              )
                            : '0'}
                        </td>
                        <td>{data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_REF_WEIGHT]}</td>
                        <td>
                          {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_SCALE]
                            ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_SCALE].toFixed(
                                APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                              )
                            : '0'}
                        </td>
                        <td>
                          {data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_OFFSET]
                            ? data[APPDATA.MESSAGES.CALIBRATION_HISTORY.BUFFER_OFFSET].toFixed(
                                APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
                              )
                            : '0'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <BottomMenu
              // id
              // showType
              // showDateTime
              // dateFormat
              // timeFormat
              // searchFilter
              // value
              // valueDateTimePopup
              // onClick
              // onCloseDatePicker
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...this.state.buttonProps}
            />
          </>
        ) : (
          <div className="center noData">
            <span>
              <b>No Data</b>
            </span>
          </div>
        )}
      </div>
    );
  }
}
export default CalibrationHistory;
